import InstructionsTitle from "./InstructionsTitle";
import InstructionsText from "./InstructionsText";
import { useState } from "react";
import { Button, Grid } from "@mui/material";

//This component is responsible for displaying the instructions title and text for a resolution event
//in a collapsed or expanded state. It is makeup of the InstructionsTitle and the InstructionsText components.
export default function Instructions() {
    const [showInstructionsText, setShowInstructionsText] = useState<boolean>(false);
    const toggleInstructionsText = () => {
        setShowInstructionsText(!showInstructionsText);
    };
    return (
        <Grid container>
            <Grid item>
                <InstructionsTitle />
            </Grid>
            <Grid item alignItems="center" style={{ display: "grid" }} paddingLeft={2}>
                <Button sx={{ width: 30, minWidth: 0, padding: 0 }} variant="contained" onClick={toggleInstructionsText} color="info">{showInstructionsText ? "-" : "+"}</Button>
            </Grid>
            <Grid item>
                {showInstructionsText && <InstructionsText />}
            </Grid>
        </Grid>
    );
}